module.exports = __webpack_public_path__ + "static/img/yy5.d8bd86c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/yy5.png
// module id = H1rM
// module chunks = 1